import { AbstractLookupStore, AbstractGetAllStore } from "../common/AbstractStores";
import { ModelloClimaDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import Actions from "./ModelliClimaActions";
import { groupBy } from "lodash";

class __ModelliClimaStore extends AbstractGetAllStore<ModelloClimaDto> {
    constructor() {
        super(x => x.id.toString());
        Dispatcher
            .onfunction(Actions.get, result => this.updateOrAdd(result))
            .onfunction(Actions.getAll, result => this.setAll(result))
            .onfunction(Actions.add, result => this.updateOrAdd(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))
            .onfunction(Actions.delete, result => {
                if (result.deleteOk) this.delete(result.idCaldaia.toString());
            })
    }

    public use(id: number | null) {
        return this.useWithAction(() => id && Actions.get(id), id?.toString() ?? null)
    }
    public useAll() {
        return this.useAllWithAction(() => Actions.getAll())
    }
}
export const ModelliClimaStore = new __ModelliClimaStore();

class __ModelliClimaByMarcaStore extends AbstractLookupStore<ModelloClimaDto> {
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getAll, result => {
                const groups = groupBy(result);
                for (const key in groups) {
                    const data = groups[key];
                    this.set(key, data);
                }
            })
            .onfunction(Actions.add, result => this.addOne(result.marca!, result, x => x.id.toString()))
            .onfunction(Actions.update, result => this.updateOne(result.marca!, result, x => x.id.toString()))
            .onfunction(Actions.getCaldaieByMarca, ({ marca, data }) => this.set(marca, data))
    }

    public useMarca = (marca: string) => this.useStoreWithAction(marca, () => Actions.getCaldaieByMarca(marca))
}
export const ModelliClimaByMarcaStore = new __ModelliClimaByMarcaStore();